import { Component, Input, OnInit } from '@angular/core';
import { PermissionsService } from '../../../../services/permissions/permissions.service';

@Component({
  selector: 'app-likert-answer',
  templateUrl: './likert-answer.component.pug',
  styleUrls: ['./likert-answer.component.scss'],
  standalone: false
})
export class LikertAnswerComponent implements OnInit {
  @Input() options:any;
  ENT_10363_PULSE_RELAUNCH = false;

  constructor(private permissionsService: PermissionsService) { }

  ngOnInit(): void {
    this.ENT_10363_PULSE_RELAUNCH = this.permissionsService.isFeatureActivated('ENT-10363-pulse-relaunch');
  }

}
